var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.data.component,_vm._b({key:_vm.index,tag:"component",staticClass:"story-background"},'component',_vm.data.bind,false))}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/base/stories/components/StoryBackground.vue?vue&type=template&id=2fd50240&
// module id = 1049
// module chunks = 0